var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_Icon_Black",
    "data-name": "Profile Icon Black",
    transform: "translate(-587.9 -62.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37821",
    "data-name": "Group 37821",
    transform: "translate(587.9 62.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65104",
    "data-name": "Path 65104",
    d: "M654.4,195.4a66.5,66.5,0,1,1,47.019-19.474A66.066,66.066,0,0,1,654.4,195.4Zm0-124.684A58.186,58.186,0,1,0,712.588,128.9,58.253,58.253,0,0,0,654.4,70.716Z",
    transform: "translate(-587.9 -62.4)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37822",
    "data-name": "Group 37822",
    transform: "translate(623.271 96.99)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_611",
    "data-name": "Ellipse 611",
    cx: 17.713,
    cy: 17.713,
    r: 17.713,
    transform: "translate(13.418 0)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65105",
    "data-name": "Path 65105",
    d: "M1470.806,1638.2a20.158,20.158,0,0,1-28.559,0,31.121,31.121,0,0,0-16.847,27.664v4.2h62.249v-4.2A31.094,31.094,0,0,0,1470.806,1638.2Z",
    transform: "translate(-1425.4 -1606.237)",
    fill: "#414042"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconBlack);
export default __webpack_public_path__ + "static/media/Profile-Icon-Black.5041430218fd76e01d4c02d7f9c4098b.svg";
export { ForwardRef as ReactComponent };